import handItemRemoveAll from './handItemRemoveAll';

/**
 * Returns a callback to reset all filter selections.
 * It iterates over summary items and handles their removal.
 * @param {Element} filter
 * @returns {Function} A callback function
 */
const handleReset = (filter) => () => {
    Array.from($(filter).find('.filter__summary__item'))
        .map(item => $(item).attr('data-id'))
        .map(itemId => handItemRemoveAll(filter, itemId))
        .forEach(removeItem => removeItem());
    $(filter).trigger('select:change');
};

export default handleReset;



// WEBPACK FOOTER //
// ./src/scripts/components/filter/handleReset.js